import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

interface Props {
  className?: string
  isLoading?: boolean
  onClick?: VoidFunction
  onMouseEnter?: VoidFunction
  onMouseLeave?: VoidFunction
}

const GridItemLayout = ({
  children,
  className,
  isLoading,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: PropsWithChildren<Props>): ReactElement => {
  return (
    <div
      className={classNames('grid-item-layout', className, { 'grid-item-layout--is-loading': isLoading })}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  )
}

export default GridItemLayout
